export default __webpack_public_path__ + "static/media/strofe_coins.ff25ae51.png";